import { ExportForm } from './components/ExportForm';
import { ExportList } from './components/ExportList';

import { Card, CardContent, CardHeader } from '@/components/ui/Card';

export function AdminVoiceToneExports() {
  return (
    <div className="min-h-screen p-6">
      <div className="mx-auto max-w-7xl space-y-8">
        <Card>
          <CardHeader>
            <h1 className="text-3xl font-semibold tracking-tight text-foreground">
              Voice Tone Exports
            </h1>
            <p className="text-sm text-muted-foreground">
              Create and track exports responsible for generating training files
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <ExportForm />
            <ExportList />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
